// The API sends expiry_date as "MM/DD/YYYY" (DRF DATE_FORMAT) and
// created_at as an ISO timestamp. A role stays open through the whole of its
// closing day.

const US_DATE = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
const DAY_MS = 24 * 60 * 60 * 1000;
const NEW_FOR_DAYS = 7;
const SHOW_COUNTDOWN_DAYS = 14;

export function parseApiDate(value) {
  if (!value) return null;
  const us = US_DATE.exec(String(value).trim());
  const date = us
    ? new Date(Number(us[3]), Number(us[1]) - 1, Number(us[2]))
    : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

const startOfDay = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

export function daysUntil(value, now = new Date()) {
  const date = parseApiDate(value);
  if (!date) return null;
  return Math.round((startOfDay(date) - startOfDay(now)) / DAY_MS);
}

export const isClosed = (expiry, now = new Date()) => {
  const days = daysUntil(expiry, now);
  return days !== null && days < 0;
};

export const isNew = (createdAt, now = new Date()) => {
  const days = daysUntil(createdAt, now);
  return days !== null && days > -NEW_FOR_DAYS;
};

export const formatDate = (value, options = { day: "numeric", month: "short", year: "numeric" }) => {
  const date = parseApiDate(value);
  return date ? date.toLocaleDateString("en-GB", options) : "";
};

// "Closes today" / "Closes in 3 days" / "Closes 30 Nov"; null when there is
// no closing date at all.
export function closingLabel(expiry, now = new Date()) {
  const days = daysUntil(expiry, now);
  if (days === null) return null;
  if (days < 0) return "Closed";
  if (days === 0) return "Closes today";
  if (days === 1) return "Closes tomorrow";
  if (days <= SHOW_COUNTDOWN_DAYS) return `Closes in ${days} days`;
  return `Closes ${formatDate(expiry, { day: "numeric", month: "short" })}`;
}

export const isClosingSoon = (expiry, now = new Date()) => {
  const days = daysUntil(expiry, now);
  return days !== null && days >= 0 && days <= 3;
};
